<template>
	<header :class="className">
		<div class="header__logo"></div>
    <h1 class="header__title" v-html="title"/>
		<div class="header__date" v-text="date"/>
    <div class="header__anons" v-html="anons"/>
	</header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
	computed: {
		...mapGetters([
			'currentArticle'
		]),
		className() {
			let classes = [ 'header' ];

			if (this.currentArticle === 'home') {
				classes.push('header--active');
			} else {
				classes.push('header--hidden');
			}

			return classes.join(' ');
		}
	},
	data() {
		return {
			title: 'Итоги года с <strong>Владимиром Путиным</strong>',
			date:  2025,
      anons: '<p>В прямом эфире телеканалов «Первый», «Россия 1», «Россия 24», НТВ, ОТР, «Мир», радиостанций «Маяк», «Вести FM» и «Радио России» проходит ежегодная программа «Итоги года <nobr>с Владимиром Путиным</nobr>»</p>',
			store: [
				{
					type:  'android',
					title: 'Установите приложение для Android',
					href:  '/static/moskva-putinu.apk',
					pdf:   '/static/moskva-putinu.pdf'
				}
			]
		}
	}
};
</script>

<style lang="scss">
@use "sass:math";
@import "../assets/scss/config";

.header {
	box-sizing: border-box;
	padding: 40px 0 0 0;
	margin: 0 $grid-gutter-page 40px;
	display: flex;
	flex-flow: wrap;
	position: relative;
	z-index: 2;

	@media screen and ($media-mobile) {
		flex-flow: row wrap;
		padding: 18px 0;
		margin: 0 4px;
	}

	&:after {
		content: '';
		position: absolute;
		bottom: 0;
		right: $grid-gutter-half;
    left: $grid-gutter-half;
		height: 1px;
		background: $color-grey-light;
    opacity: 0.2;

		@media screen and ($media-mobile) {
			right: 12px;
			width: calc(100% - 24px);
		}
	}

	&__logo {
		box-sizing: border-box;

    padding: 0 $grid-gutter-half;
    flex: 0 0 math.div(3 * 100%, 12);

		@media screen and ($media-mobile) {
			flex: none;
      padding-right: 0;
		}

		&:before {
			content: '';
			display: block;
			height: 100px;
			width: 100px;
			background: transparent url(../assets/images/putin.jpg) center / 180% no-repeat;
			border-radius: 16px;
			overflow: hidden;
      background-size: contain;

			@media screen and ($media-mobile) {
				width: 56px;
				height: 56px;
        flex: 0;
			}
		}
	}

  &__anons {
    padding: 0 $grid-gutter-half;
    margin-left: math.div(3 * 100%, 12);
    padding-right: math.div(3 * 100%, 12);
    font: 13px/125% 'GolosText', sans-serif;
    position: relative;

    @media screen and ($media-mobile) {
      font-size: 10px;
      line-height: 125%;
      padding-right: 50px;
      margin-left: 68px;
    }

    p {
      padding: 0;
      margin: 0 0 32px 0;
      @media screen and ($media-mobile) {
        margin: 24px 0 0 0;
      }
    }

    &:before {
      content: '';
      height: 40px;
      width: 40px;
      background: transparent url(../assets/images/coat-of-arms-grey.svg) center / cover no-repeat;
      position: absolute;
      right: 12px;
      top: 0;
      @media screen and ($media-mobile) {
        width: 25px;
        height: 25px;
        top: auto;
        bottom: 0;
      }
    }
  }

	&__title {
		box-sizing: border-box;

    padding: 0 $grid-gutter-half;
    flex: 0 0 math.div(6 * 100%, 12);
    margin: 0 auto 40px 0;

		font: 48px/105% 'GolosText', sans-serif;
    letter-spacing: -0.02em;

		@media screen and ($media-mobile) {
			flex: 0 0 50%;
			margin: 0;
      font-size: 20px;
      line-height: 95%;
      letter-spacing: normal;
      font-weight: 500;
		}

    //@media screen and ($media-xmobile) {
    //  flex: 0 0 100%;
    //}

    strong {
      font-weight: normal;
      white-space: nowrap;
      @media screen and ($media-tablet) {
        white-space: normal;
      }
    }

	}

	&__date {
		box-sizing: border-box;
    padding: 0 $grid-gutter-half;
    //flex: 0 0 math.div(3 * 100%, 12);
    text-align: right;
    margin-left: auto;
		font: 48px/105% 'GolosText', sans-serif;
    letter-spacing: -0.02em;

		@media screen and ($media-mobile) {
			flex: auto;
			margin: 0;
      justify-content: flex-end;
      font-size: 20px;
      line-height: 95%;
      font-weight: 500;
		}
	}

	&__link {
		box-sizing: border-box;
		width: 100%;
		padding: 22px 40px;
		display: flex;
		flex-flow: row nowrap;
		justify-content: flex-start;
		align-items: center;
		background: $color-grey;
		text-decoration: none;
		border-radius: 16px;
		margin: -12px 0 0;


		&:before {
			content: '';
			width: 28px;
			height: 34px;
			flex: 0 0 28px;
			background: transparent url(../assets/images/android-white.svg) center / contain no-repeat;
		}

		span {
			font: 16px/20px 'RF Devi Semi Bold', sans-serif;
			color: $color-white;
			margin: auto 0 auto 24px;
		}
	}

	&__file {
		position: absolute;
		bottom: -20px;
		left: 0;
		right: 0;
		text-align: center;
		font: 14px/14px 'RF Devi', sans-serif;
		color: #2D3B57;
		opacity: 0.5;
	}
}
</style>